import "./CustomerBooking.css";
import "../../App.css";
import Carousel from "react-elastic-carousel";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { SyncLoader } from "react-spinners";
import { format, parseISO } from "date-fns";
import { formatCurrency } from "../../config/currency";

function CustomerBooking() {
  const navigate = useNavigate();

  const [step, setStep] = useState("schedule");
  const [loaderon, setloaderon] = useState(false);
  const [disablebutton, setdisablebutton] = useState(false);

  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [packagesLoading, setPackagesLoading] = useState(false);

  const [AllDate, setAllDate] = useState([]);
  const [activeDate, setActiveDate] = useState(null);
  const [activeDay, setActiveDay] = useState(null);
  const [TimeSlot, setTimeSlot] = useState([]);
  const [SelectedSlot, setSelectedSlot] = useState(null);
  const [Price, setPrice] = useState("");

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 4, itemsToScroll: 2, pagination: false },
    { width: 768, itemsToShow: 5 },
    { width: 1150, itemsToShow: 5, itemsToScroll: 2 },
    { width: 1440, itemsToShow: 6 },
    { width: 1750, itemsToShow: 6 },
  ];

  function showAdvanceSlot(selectedDate) {
    const url = window.API_PREFIX + "timing/showslot_advance";
    fetch(url, {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
        Date: selectedDate,
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.status === "1") {
          setTimeSlot([...data.TotalSlot]);
        }
      });
  }

  useEffect(() => {
    const url = window.API_PREFIX + "timing/show_slot";
    fetch(url, {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({ Token: localStorage.getItem("DToken") }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.status === "1") {
          setTimeSlot([...data.TotalSlot]);
          setAllDate([...data.date_List]);
          setActiveDate(data.date_List[0].Date);
          setActiveDay(data.date_List[0].Day);
          setPrice(data.Price);
        }
      });
  }, []);

  useEffect(() => {
    if (step !== "package") return;
    setPackagesLoading(true);
    const url = window.API_PREFIX + "booking/packages";
    fetch(url)
      .then((resp) => resp.json())
      .then((data) => {
        if (data.status === "1") {
          setPackages(data.packages || []);
        }
        setPackagesLoading(false);
      })
      .catch(() => setPackagesLoading(false));
  }, [step]);


  const renderBackHeader = (title, onBack) => (
    <div className="package_select_header">
      <button type="button" className="btn Reviewdetails_back_button" onClick={onBack}>
        <i className="fa-solid fa-arrow-left back_icon" />
        Back
      </button>
      <h2 className="package_select_heading">{title}</h2>
    </div>
  );

  const renderSlotBanner = () => (
    <div className="package_select_selected_banner">
      <strong>
        {activeDay}
        {activeDate ? ` — ${format(parseISO(activeDate), "dd-MM-yyyy")}` : ""}
      </strong>
      {SelectedSlot && <span> · {SelectedSlot}</span>}
    </div>
  );

  if (step === "schedule") {
    return (
      <main className="container-fluid mx-2">
        {renderBackHeader("Select Date & Time", () => navigate("/dashboard"))}
        <div className="package_select_page purpose_of_visit_division_container">
          <div className="d-flex justify-content-center mt-3">
            <div>
              <i className="fa-solid fa-square me-2 indication_1" />
              Available
            </div>
            <div className="ms-2">
              <i className="fa-solid fa-square me-2 indication_2" />
              Not Available
            </div>
            <div className="ms-2">
              <i className="fa-solid fa-square me-2 indication_3" />
              Selected
            </div>
          </div>
          <div className="client_booking_main_diviison">
            <div className="client_booking_diviison">
              <div className="client_booking_week_division">
                <Carousel breakPoints={breakPoints}>
                  {AllDate.map((eachDay) => (
                    <div
                      key={eachDay.Date}
                      onClick={() => {
                        setActiveDate(eachDay.Date);
                        setActiveDay(eachDay.Day);
                        showAdvanceSlot(eachDay.Date);
                      }}
                      className={
                        activeDate === eachDay.Date
                          ? "client_booking_week_name_active"
                          : "client_booking_week_name"
                      }
                    >
                      <div>{eachDay.Day}</div>
                      <div
                        className={
                          eachDay.Date
                            ? "client_booking_day_name_active"
                            : "client_booking_day_name"
                        }
                      >
                        {eachDay.Date
                          ? format(parseISO(eachDay.Date), "dd-MM-yyyy")
                          : ""}
                      </div>
                    </div>
                  ))}
                </Carousel>
              </div>
              {TimeSlot.length > 0 ? (
                <div className="client_booking_time_slot_table_division">
                  {TimeSlot.map((eachTimeSlot) => (
                    <div
                      key={eachTimeSlot.Slot}
                      className={
                        !eachTimeSlot.Flag
                          ? "client_booking_time_slots_active"
                          : eachTimeSlot.Slot === SelectedSlot
                            ? "client_booking_time_slots_active_selected"
                            : "client_booking_time_slots"
                      }
                      onClick={() => {
                        if (eachTimeSlot.Flag === 1) {
                          setSelectedSlot(eachTimeSlot.Slot);
                        }
                      }}
                    >
                      {eachTimeSlot.Slot}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center mt-5 mb-5">
                  There are no slots available
                </div>
              )}
            </div>
            <div className="client_booking_proceedpay_button_division">
              <button
                type="button"
                className="btn client_booking_proceedpay_button"
                disabled={SelectedSlot === null}
                onClick={() => setStep("package")}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </main>
    );
  }

  if (step === "package") {
    return (
      <main className="container-fluid mx-2">
        {renderBackHeader("Select Package", () => setStep("schedule"))}
        <div className="package_select_page">
          {renderSlotBanner()}
          {packagesLoading ? (
            <div className="package_select_empty text-center py-5">
              <SyncLoader color="#f36f21" />
            </div>
          ) : packages.length === 0 ? (
            <div className="package_select_empty text-center py-5">
              No packages available. Please contact the clinic.
            </div>
          ) : (
            <div className="package_select_grid">
              {packages.map((pkg) => (
                <div
                  key={pkg.id}
                  className={
                    selectedPackage?.id === pkg.id
                      ? "package_select_card package_select_card_active"
                      : "package_select_card"
                  }
                  onClick={() => setSelectedPackage(pkg)}
                  onKeyDown={() => {}}
                  role="button"
                  tabIndex={0}
                >
                  <div className="package_select_icon_wrap">
                    <i className="fa-solid fa-star package_select_icon" />
                  </div>
                  <h3 className="package_select_title">{pkg.title}</h3>
                  <p className="package_select_price_duration">
                    {formatCurrency(pkg.price)} /{pkg.duration}
                  </p>
                  <p className="package_select_included_label">What&apos;s included</p>
                  <ul className="package_select_inclusions">
                    {(pkg.inclusions || []).map((item, idx) => (
                      <li key={idx}>
                        <i className="fa-solid fa-check package_select_check" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          )}
          <div className="package_select_footer">
            <button
              type="button"
              className="btn client_booking_proceedpay_button"
              disabled={!selectedPackage}
              onClick={() => setStep("review")}
            >
              Next
            </button>
          </div>
        </div>
      </main>
    );
  }

  const displayPrice = selectedPackage ? selectedPackage.price : Price;

  return (
    <div className="d-flex justify-content-center mt-2">
      <div>
        <button
          className="btn Reviewdetails_back_button mx-2"
          type="button"
          onClick={() => setStep("package")}
        >
          <i className="fa-solid fa-arrow-left back_icon" />
          Back
        </button>
        <div className="Reviewdetails_main_division mt-2">
          <div className="Reviewdetails_division">
            <p className="Reviewdetails_summary_name">Booking summary</p>
            <div className="reviewdetails_date_time_fee_division">
              <div className="reviewdetails_leftside">Date</div>
              <div className="reviewdetails_rightside">
                {activeDate ? format(parseISO(activeDate), "dd-MM-yyyy") : ""}
              </div>
            </div>
            <div className="reviewdetails_date_time_fee_division">
              <div className="reviewdetails_leftside">Time</div>
              <div className="reviewdetails_rightside">{SelectedSlot}</div>
            </div>
            {selectedPackage && (
              <div className="review_package_summary mb-3 mt-3">
                <h4 className="review_package_summary_title">
                  {selectedPackage.title}
                </h4>
                <p className="review_package_summary_meta">
                  {formatCurrency(selectedPackage.price)} /{selectedPackage.duration}
                </p>
                {(selectedPackage.inclusions || []).length > 0 && (
                  <ul className="package_select_inclusions mt-2">
                    {selectedPackage.inclusions.map((item, idx) => (
                      <li key={idx}>
                        <i className="fa-solid fa-check package_select_check" />
                        {item}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
            <div className="reviewdetails_date_time_fee_division">
              <div className="reviewdetails_leftside">Consulting fee</div>
              <div className="reviewdetails_rightside">{formatCurrency(displayPrice)}</div>
            </div>
            <div className="reviewdetails_date_total_division">
              <div className="reviewdetails_total">Total</div>
              <div className="reviewdetails_rightside">{formatCurrency(displayPrice)}</div>
            </div>
            <div className="client_booking_proceedpay_button_division">
              <button
                type="button"
                className="btn client_booking_proceedpay_button"
                disabled={disablebutton}
                onClick={() => {
                  if (disablebutton || !selectedPackage) return;
                  setdisablebutton(true);
                  setloaderon(true);
                  const url = window.API_PREFIX + "booking/booking";
                  fetch(url, {
                    method: "POST",
                    headers: { "Content-type": "application/json" },
                    body: JSON.stringify({
                      Token: localStorage.getItem("DToken"),
                      Slot: SelectedSlot,
                      Date: activeDate,
                      PackageId: selectedPackage.id,
                    }),
                  })
                    .then((resp) => resp.json())
                    .then((data) => {
                      if (data.status === "1") {
                        toast.success("Sent for approval");
                        navigate("/dashboard");
                      } else {
                        toast.error(data.message || "Booking failed");
                        setdisablebutton(false);
                      }
                      setloaderon(false);
                    })
                    .catch(() => {
                      toast.error("Booking failed");
                      setdisablebutton(false);
                      setloaderon(false);
                    });
                }}
              >
                {loaderon ? (
                  <SyncLoader color="white" />
                ) : (
                  "Request Appointment"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerBooking;
